import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { openTSDialog } from 'src/app/helpers/methods';
import { SignupService } from '@app-services/signup/signup.service';
import { GAnalyticsService } from '@app-services/g-analytics/g-analytics.service';
import { openDefaultLoginDialog, openTermsAndConditionsDialog, signup, socialMediaClicked } from '@app-core/components/home/home.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TenantConstant } from '@app-constants/tenant.constant';
import { Meta, Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { UserService } from '@app-services/user/user.service';
import { SubscriptionService } from '@app-services/subscription/subscription.service';
import { nextSlide, prevSlide } from '../ilite/ilite.component';

@Component({
  selector: 'app-repeater',
  templateUrl: './repeater.component.html',
  styleUrls: ['../ilite/ilite.component.scss', './repeater.component.css']
})
export class RepeaterComponent implements OnInit {
  mobileNumberValid = false;
  signup = signup;
  openTermsAndConditionsDialog = openTermsAndConditionsDialog;
  socialMediaClicked = socialMediaClicked;
  openTSDialog = openTSDialog;
  openDefaultLoginDialog = openDefaultLoginDialog;
  nextFac = nextSlide;
  prevFac = prevSlide;
  tenant: any = TenantConstant.tenant;
  public mobileNumber: any = '';
  public PackageDetails:any = {}
  constructor(public signUpService: SignupService, private dialog: MatDialog, private gaService: GAnalyticsService, public subscriptionservice : SubscriptionService, public modalservice:NgbModal,
    private titleService: Title,
    private metaService: Meta,
    public router: Router,
    public userService: UserService,) { 
  }
  ngOnInit(): void {
    if (this.tenant != 'infinitylearn') {
      this.router.navigate(['/']);
      return;
    }
    
    this.titleService.setTitle('Online Repeater Batch for NEET and JEE | Infinity Learn');
    this.metaService.addTags([
      {name: 'keywords', content: 'neet repeater, neet repeater course, repeaters batch for neet, jee repeater course, neet 2022, jee 2022, neet classes, jee classes, neet coaching near me, jee coaching near me, neet clasess near me, jee classes near me, neet coaching, jee coaching, best coaching for neet, best coaching for jee'},
      {name: 'description', content: 'Better performance at NEET and JEE will help you in getting admission to top colleges. Apply now for an online repeater/dropper batch only at Infinity Learn.'},
    ])
    //this.modalservice.open(IliteModalComponent)
  }
  ngAfterViewInit(){
  }
  openSignUpDialog(numberAndIsd: any, hiddenFields?: any) {
    this.openTSDialog({
      message: 'One more step and you are all set',
        source: 'REPEATER',
        phone: numberAndIsd?.number,
        countryCode: numberAndIsd?.dialCode,
        grade: '13th',
        hiddenFields: {hallticket: true, state: true},
        disabledFields: {phone: true, grade: true, source: true },
        REPEATER: true
    })  
  }

  ngOnDestroy(){
  }
}
